import { api } from "./axiosClient";
import type { Role, DisplayTemplateResponse } from "../types/roles.types";

export const rolesApi = {
  searchRoles: async (payload: any) => {
    const response = await api.post<{ data: Role[]; count: number }>(
      "/Role/Search",
      payload,
    );
    return response.data;
  },

  getDisplayTemplate: async (
    id: string = "f62f9250-3eb4-4180-b0d0-948b19f7455c",
  ) => {
    const response = await api.post<DisplayTemplateResponse>(
      "/Role/displaytemplate",
      { id },
    );
    return response.data;
  },

  createRole: async (data: Partial<Role>) => {
    const response = await api.post("/Role/create", data);
    return response.data;
  },

  updateRole: async (data: { id: string; roleName: string; allowedPermissions: string[] }) => {
  const response = await api.post("/Role/edit", data);
  return response.data;
},

  activateRole: async (id: string) => {
    return await api.post("/Role/activate", { id });
  },

  deActivateRole: async (id: string) => {
    return await api.post("/Role/deactivate", { id });
  },

  publishRole: async (id: string) => {
    return await api.post("/Role/publish", { id });
  },

  revertRole: async (id: string) => {
    return await api.post("/Role/revert", { id });
  },

  removeRole: async (id: string) => {
    return await api.post("/Role/remove", { id });
  },
};
